import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function DayHospital() {
  return (
    <section className="dayHospital">
      <Breadcrumbs />

      <h1>Дневной стационар</h1>
    </section>
  );
}
